// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"c9301172","126":"8fe0a5c1","147":"df2ebff8","171":"e8f0b58d","374":"8944bcbc","388":"02073e34","507":"7e06f0e0","528":"ee91682d","780":"0a390cbf"}[chunkId] + ".chunk.js";
};